import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";


export default function StudentCaseStudyPractice() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get(`/student/case-study-practice/${id}/start`)
      .then((res) => setData(res.data))
      .catch(() => alert("Failed to load case study practice"));
  }, [id]);

  if (!data) return <p>⏳ Loading...</p>;

  return (
    <div style={{ padding: 24 }}>
      <h2>{data.title}</h2>

      {data.case_studies.map((cs, i) => (
        <div key={cs.id} style={box}>
          <h3>{i + 1}. {cs.title}</h3>
          <p style={{ whiteSpace: "pre-wrap" }}>{cs.description}</p>

          {cs.questions.map((q, idx) => (
            <div key={q.id} style={qBox}>
              <p><b>Q{idx + 1}.</b> {q.text}</p>
              <label><input type="radio" name={q.id} /> {q.option_a}</label><br />
              <label><input type="radio" name={q.id} /> {q.option_b}</label><br />
              <label><input type="radio" name={q.id} /> {q.option_c}</label><br />
              <label><input type="radio" name={q.id} /> {q.option_d}</label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

const box = {
  background: "#fff",
  padding: 16,
  marginBottom: 20,
  borderRadius: 12,
};

const qBox = {
  padding: 12,
  marginTop: 10,
  background: "#f8fafc",
  borderRadius: 8,
};
